import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import PageMeta from "./PageMeta";

const items = [
  { name: "Caps", image: "assets/rsaa_caps.png" },
  { name: "Car Window Stickers", image: "assets/rsaa_car_window_stickers.png" },
  { name: "Hoodies", image: "assets/rsaa_hoodies.png" },
  { name: "T-Shirts", image: "assets/rsaa_tshirts.png" },
];

export default function MerchandisePage() {
  return (
    <div className="relative page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Club Merchandise | Redruth Sea Angling Association"
        description="Browse Redruth Sea Angling Association club merchandise — clothing and gear branded for Cornwall's sea angling club."
        keywords="RSAA merchandise, sea angling club clothing, Redruth Sea Angling Association shop"
        url="https://www.redruthseaanglingassociation.co.uk/merchandise"
      />
      <img
        src="/assets/merchandise_background.webp"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-slate-950/75" />
      <div className="relative mx-auto max-w-5xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8 flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cyan-400/10">
            <ShoppingBag className="h-6 w-6 text-cyan-300" />
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
            <h1 className="heading-glow mt-1 text-3xl font-bold tracking-tight text-white sm:text-4xl">Club Merchandise</h1>
          </div>
        </div>

        <div className="mt-6 rounded-xl border border-cyan-300/20 bg-cyan-400/5 px-6 py-5 panel-lift">
          <p className="text-sm leading-7 text-slate-200">
            RSAA club merchandise can be ordered from{" "}
            <span className="font-semibold text-white">Graeme Hicks</span> or at any{" "}
            <span className="font-semibold text-white">RSAA Monthly Meeting</span>.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          {items.map((item) => (
            <div
              key={item.name}
              className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition hover:border-cyan-300/30 hover:bg-cyan-400/5"
            >
              <img
                src={item.image}
                alt={`RSAA ${item.name}`}
                className="w-full object-contain bg-slate-900"
                style={{ maxHeight: '320px' }}
              />
              <div className="px-5 py-4">
                <h2 className="text-base font-semibold text-white">{item.name}</h2>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-slate-400">
          To place an order, speak to Graeme Hicks or visit us at a{" "}
          <Link to="/" className="text-cyan-400 hover:text-cyan-300 underline">monthly meeting</Link>.
        </p>

      </div>
    </div>
  );
}

